import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    ListCustomCostProvidersResponse,
    UseListCustomCostProvidersParams,
    UseListCustomCostProvidersResult,
} from './types';

const useListCustomCostProviders = ({
    month,
    enabled,
}: UseListCustomCostProvidersParams): UseListCustomCostProvidersResult => {
    const searchParams = new URLSearchParams({ month });
    const pathname = `/admin/platform-costs/custom-providers?${searchParams.toString()}`;

    const { data, isLoading, refetch } = useHttpQuery<ListCustomCostProvidersResponse>({
        pathname,
        method: 'GET',
        key: ['admin-platform-costs-custom-providers', month],
        queryOptions: {
            enabled: enabled && month.length > 0,
        },
    });

    return {
        providers: data?.data.providers ?? [],
        isLoadingProviders: isLoading,
        refetch,
    };
};

export default useListCustomCostProviders;
